import { render, staticRenderFns } from "./profilmenu.vue?vue&type=template&id=504987a3&scoped=true&"
import script from "./profilmenu.vue?vue&type=script&lang=js&"
export * from "./profilmenu.vue?vue&type=script&lang=js&"
import style0 from "./profilmenu.vue?vue&type=style&index=0&id=504987a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504987a3",
  null
  
)

export default component.exports